import { render, staticRenderFns } from "./sendmanWallet.vue?vue&type=template&id=2806908c&scoped=true&"
import script from "./sendmanWallet.vue?vue&type=script&lang=js&"
export * from "./sendmanWallet.vue?vue&type=script&lang=js&"
import style0 from "./sendmanWallet.vue?vue&type=style&index=0&id=2806908c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806908c",
  null
  
)

export default component.exports